import { Component, OnInit } from '@angular/core';
import { routerTransition } from '@app/router.animations';
import { KycService } from '@app/core/kyc.service';
import { AgentInfo } from '@app/core/models/agent';
import { Router } from '@angular/router';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  animations: [routerTransition()],
  host: { '[@routerTransition]': '' }
})
export class ThankYouComponent implements OnInit {
  agent: AgentInfo;

  constructor(
    private _kycService: KycService,
    private router: Router) {
    this.agent = new AgentInfo();
  }

  ngOnInit() {
    if (this._kycService.kyc.agentInfo) {
      this.agent = this._kycService.kyc.agentInfo;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/features/thank-you/thank-you.component.ts